/*
 * Public API Surface of pepperi-lib/separator
 */
export * from './separator.module';
export * from './separator.component';
